import { serviceRequest } from '../service-request';

export function enterViewAsUserMode(displayedUserId: string) {
	return serviceRequest('svc/settings/view-as-user', { displayedUserId }, { method: 'POST', useSubmissionToken: true });
}

export function exitViewAsUserMode() {
	return serviceRequest('svc/settings/view-as-user/exit', null, { method: 'POST', useSubmissionToken: true });
}